import { useGetMarketsQuery } from '../api';
import { marketTransformer } from '../helpers';

export function useMarketsView() {
  const { data: markets } = useGetMarketsQuery();
  return markets?.map(marketTransformer);
}
